// export const API_URL="https://aiagent.aihear.io"//生产环境
//const API_URL="http://192.168.112.84:8081/ai/customer"//测试环境apiai-deven-temp.elehear.cn.elehear.cn
//const API_URL="https://apiai-deven.elehear.cn"//测试环境aiagent-v2.aihear.io
//const API_URL="https://aiagent-v2.aihear.io"//正式环境
const API_URL="https://apiai-deven.elehear.cn"//正式环境
//http://192.168.112.182:3000/?productType=7&userId=445556565

/**
 * @typedef {Object} ServerAudioParameter
 * @property {string} name - 参数名称 (如 '低频EQ', '声台')
 * @property {number} type - 协议中的 Type 值 (如 4 for EQ, 1 for 声台, 3 for 响度)
 * @property {number} direction - 调整方向 (1: 调大, -1: 调小)
 * @property {number} channel - 1: 左耳, 2: 右耳
 * @property {number | undefined} value - 适用于 Type 1, 2 的 'value'
 * @property {number | undefined} eq - 适用于 Type 4, 3 的 'eq' 值 (调节步长)
 * @property {number | undefined} ratio1 - 适用于 Type 3 的 'ratio1' 值
 * @property {number | undefined} ratio2 - 适用于 Type 3 的 'ratio2' 值
 * @property {number | undefined} threshold2 - 适用于 Type 3 的 'threshold2' 值
 */

/**
 * 将服务器传来的音频参数数据转换为 APP 期望的协议 JSON 字符串。
 * @param {ServerAudioParameter[]} serverData - 服务器传来的参数数组。
 * @returns {string[]} - 符合 APP 协议格式的 JSON 字符串数组。
 */
function transformServerDataForApp(param) {
    if (!param) {
        console.error("服务器数据格式错误");
        return [];
    }

    const appProtocolMessages = [];

    let data = {};
    const ServerType = param.type;
    const setValue = param.value;
    let type = ServerType;
    let direction =  1; // 默认调大 (1)
    if(ServerType % 2 === 0){
        direction =  -1;
    }

    if(ServerType >= 17){
        direction = 0; // 设置固定值
    }
    
    // 基础结构: channel
    // 注意: 协议中 'channel' 的描述是 "1/1: 左耳, 2: 右耳"，这里假设实际发送 '1' 或 '2'
    let channel =  1; 
    if(param.channel === "L"){
        channel =  1;
    } else if(param.channel === "R"){
        channel =  2;
    }else{
        channel = 3; // 双耳
    }
    // 噪声
    if (ServerType === 1 || ServerType === 2) {
        const queryParams = new URLSearchParams(window.location.search);
        const productType = queryParams.get("productType");
        data = {
            "value": 1,
            "channel": channel
        };
        if(productType === "7" || productType === "9"){//aihear pro
            data.value = 2;
        }
        type = 2;
    } 
    else if (ServerType === 15 || ServerType === 16) {
        data = {
            "value": 3,
            "channel": channel
        };
        type = 1;
    } 
    else if (ServerType >= 9  && ServerType <= 14) {//大中小声
        data = {
            "eq": 2,
            "ratio1": 0.018,
            "threshold2": 2,
            "channel": channel
        };
        if (ServerType >= 9  && ServerType <= 10){//xiao
            data.ratio1 = 0.018;
            data.threshold2 = 0;
            data.eq = 2;
        }else if (ServerType >= 11  && ServerType <= 12){//zhong
            data.ratio1 = 0.018;
            data.threshold2 = 4;
            data.eq = 0;
        } else if (ServerType >= 13  && ServerType <= 14){//da
            data.ratio1 = 0;
            data.threshold2 = 4;
            data.eq = 0;
        }
        type = 3;
    } 
    else if (ServerType >= 3  && ServerType <= 8) {//高中低频 EQ
        data = {
            "eq": 3,
            "scope": "low",
            "channel": channel
        };
        if (ServerType === 3  || ServerType === 4){
            data.scope = "high";
        }else if (ServerType === 5  || ServerType === 6){
            data.scope = "middle";
        }   else if (ServerType === 7  || ServerType === 8){
            data.scope = "low";
        }   
        type = 4;
    } 
    else if (ServerType === 0) {//恢复出厂设置
        data = null;
        direction = 0;
        type = 5;
    } 
    else if (ServerType >= 17 && ServerType <= 21) {//降噪相关
        data = {
            "level": 5, //0~7
            "auto": 0,
            "channel": channel
        };
        if (ServerType === 17){
            data.level = 5;
            data.auto = 0;
        }else if (ServerType === 18){
            data.level = setValue;
            data.auto = 0;
        }else if (ServerType === 19){
            data.level = 0;
            data.auto = 0;
        }else if (ServerType === 20){
            data.level = 5;
            data.auto = 1;
        }else if (ServerType === 21){
            data.level = 5;
            data.auto = 0;
        }
        type = 6;
    } 
    else if (ServerType === 24 ||  ServerType === 25 ) {//指向性
        data = {
            "value": 2,
            "channel": channel
        };
        if (ServerType === 25){
            data.value = 3;
        }
        type = 7;
    } 
    else if (ServerType === 22) {//音量调到固定值
        data = {
            "value": setValue,
            "channel": channel
        };
        type = 8;
    } 
    else if (ServerType === 23) {//音调调到固定值
        data = {
            "value": setValue,
            "channel": channel
        };
        type = 9;
    } 
    else if (ServerType >= 26 && ServerType <= 28 ) {//助听功能开关
        data = {
            "value": 2,
            "channel": channel
        };
        if (ServerType === 27){
            data.value = 1;
        }else if (ServerType === 28){
            data.value = 0;
        }
        type = 10;
    } 
    else if (ServerType === 29 ||  ServerType === 30 ) {//通话增强开关
        data = {
            "value": 1,
            "channel": channel
        };
        if (ServerType === 30){
            data.value = 0;
        }
        type = 11;
    } 
    else if (ServerType === 31 ||  ServerType === 32 ) {//headset 1  Hearing aid mode 0
        data = {
            "value": 1,
            "channel": channel
        };
        if (ServerType === 32){
            data.value = 0;
        }
        type = 12;
    } 
    else {
        console.warn(`未知协议 Type: ${ServerType}，跳过此参数。`);
        return null;
    }

    // 构造最终消息对象
    const messageObject = {
        "type": type,
        "direction": direction,
        "data": data
    };

    // 转换为 JSON 字符串并添加到数组
    return JSON.stringify(messageObject, null, 4);
}

//UI显示的数据转换函数
function transformData2UI(param) {
    if (!param) {
        console.error("服务器数据格式错误");
        return [];
    }

    let data = {};
    const ServerType = param.type;
    const setValue = param.value;
    let direction =  1; // 默认调大 (1)
    if(ServerType % 2 === 0){
        direction =  -1;
    }
    // 基础结构: channel
    // 注意: 协议中 'channel' 的描述是 "1/1: 左耳, 2: 右耳"，这里假设实际发送 '1' 或 '2'
    let channel =  1; 
    if(param.channel === "L"){
        channel =  1;
    } else if(param.channel === "R"){
        channel =  2;
    }else{
        channel = 3; // 双耳
    }

    let DerectionStr = "Enhanced";
    if(direction === -1){
        DerectionStr = "Reduced";
    } else if(direction === 0){
        DerectionStr = "Reset";
    }   

    if(ServerType >= 17){
        DerectionStr = "Set";
    }

    if(ServerType === 0){
        DerectionStr = "";
    }
    // 噪声
    if (ServerType === 1 || ServerType === 2) {
        data = {
            "title": "Noise Reduction",
            "subTitle": "Quiet Places",
            "stronger": "Stronger",
            "function": "Noise Reduction",
            "step": "+1",
            "channel": channel
        };
        if(direction === -1){
            data.stronger = "Softer";
            data.step = "-1";
        }

        const queryParams = new URLSearchParams(window.location.search);
        const productType = queryParams.get("productType");
       
        if(productType === "7" || productType === "9"){//beyond pro
            data.step = "+2";
            if(direction === -1){
                data.step = "-2";
            }
        }
        
    } 
    else if (ServerType === 15 || ServerType === 16) {//声音大小 
        data = {
            "title": "Overall Loudness",
            "subTitle": "Overall Sound",
            "stronger": "Louder",
            "function": "Overall Gain",       
            "step": "+3dB",
            "channel": channel
        };
        if(direction === -1){
            data.stronger = "Softer";
            data.step = "-3dB";
        }
    } 
    else if (ServerType >= 9  && ServerType <= 14) {//大中小声
        data = {
            "title": "Overall Loudness",
            "subTitle": "Overall Sound",
            "stronger": "Louder",
            "function": "Overall Gain",       
            "step": "+3dB",
            "channel": channel
        };
        if(direction === -1){
            data.stronger = "Softer";
            data.step = "-3dB";
        }

        if(ServerType == 9  || ServerType == 10){//小声
            data.title = "Soft Sounds";
            data.subTitle = "Soft Sounds Clearer";
            data.function = "Low Input Gain";
            if(ServerType == 10){
                data.subTitle = "Soft Sounds Quieter";
            }
        }else if(ServerType == 11  || ServerType == 12){
            data.title = "Moderate Sounds";
            data.subTitle = "Conversation Louder";
            data.function = "Mid Input Gain";
            if(ServerType == 12){
                data.subTitle = "Conversation Softer";
            }
        }else if(ServerType == 13  || ServerType == 14){
            data.title = "Loud Sounds";
            data.subTitle = "Loud Sounds Louder";
            data.function = "High Input Gain";
            if(ServerType == 14){
                data.subTitle = "Loud Sounds Softer";
            }
        }
        
    } 
    else if (ServerType >= 3  && ServerType <= 8) {//高中低频 EQ
        data = {
            "title": "Enhanced Overall Loudness",
            "subTitle": "Overall Sound Louder",
            "stronger": "Louder",
            "function": "Overall Gain",       
            "step": "+3dB",
            "channel": channel
        };
        if(direction === -1){
            data.stronger = "Softer";
            data.step = "-3dB";
        }

        if(ServerType == 3  || ServerType == 4){//高频 EQ
            data.title = "Speech Clarity";
            data.subTitle = "Better High Tones";
            data.function = "High EQ";
            if(ServerType == 4){
                data.title = "Harsh High Tones";
                data.subTitle = "High Tones Softer";
            }
        }else if(ServerType == 5  || ServerType == 6){
            data.title = "Voice Focus";
            data.subTitle = "Voice Focus Stronger";
            data.function = "Mid EQ";
            if(ServerType == 6){
                data.title = "Voice Intensity";
                data.subTitle = "Voice Softer";
            }
        }else if(ServerType == 7  || ServerType == 8){
            data.title = "Low-End Warmth";
            data.subTitle = "Low Tones Fuller";
            data.function = "Low EQ";
            if(ServerType == 8){
                data.title = "Low-End Muddiness";
                data.subTitle = "Low Tones Cleaner";
            }
        }
    } 
    else if (ServerType === 0) {//恢复出厂设置
        data = {
            "title": "Reset To Factory Default",
            "subTitle": "Factory Reset",
            "stronger": " ",
            "function": "Factory Reset",       
            "step": "",
            "channel": 3
        };
    } 
    else if (ServerType >= 17  && ServerType <= 21) {//降噪相关
        data = {
            "title": "Settings Updated",
            "subTitle": "Noise Reduction",
            "stronger": setValue,
            "function": "",
            "step": "Set to specified level",
            "channel": channel
        };
       
        if(ServerType == 17){//
            data.subTitle = "Noise Reduction";
            data.stronger = "Turned On";
        }else if(ServerType == 19){
            data.subTitle = "Noise Reduction";
            data.stronger = "Turned Off";
        }else if(ServerType == 20){
            data.subTitle = "Auto Noise Reduction";
            data.stronger = "Turned On";
        }
        else if(ServerType == 21){
            data.subTitle = "Auto Noise Reduction";
            data.stronger = "Turned Off";
        }
    } 
    else if (ServerType === 22 ) {//设置固定声音大小 
        data = {
            "title": "Settings Updated",
            "subTitle": "Overall Volume",
            "stronger": setValue,
            "function": "",       
            "step": "Set to specified level",
            "channel": channel
        };
    } 
    else if (ServerType === 23 ) {//设置固定音调大小 
        data = {
            "title": "Settings Updated",
            "subTitle": "Overall Tone",
            "stronger": setValue,
            "function": "",       
            "step": "Set to specified level",
            "channel": channel
        };
    } 
    else if (ServerType === 24 || ServerType === 25 ) {//设置指向性
        data = {
            "title": "Settings Updated",
            "subTitle": "Speech Focus",
            "stronger": "Turn On",
            "function": "",       
            "step": "Set to specified level",
            "channel": channel
        };
        if(ServerType == 25){
            data.stronger = "Turn Off";
        }
    } else if (ServerType === 26 || ServerType === 27 || ServerType === 28  ) {//设置助听功能开关
        data = {
            "title": "Settings Updated",
            "subTitle": "Hearing Aid Function",
            "stronger": "Keep Turned On",
            "function": "",       
            "step": "Set to specified level",
            "channel": channel
        };
        if(ServerType == 27){
            data.stronger = "Keep Turned Off";
        }else if(ServerType == 28){
            data.stronger = "Auto";
        }
    } else if (ServerType === 29 || ServerType === 30 ) {//通话增强
        data = {
            "title": "Settings Updated",
            "subTitle": "Phone Call Boost",
            "stronger": "Turn On",
            "function": "",       
            "step": "Set to specified level",
            "channel": channel
        };
        if(ServerType == 30){
            data.stronger = "Turn Off";
        }
    }else if (ServerType === 31 || ServerType === 32 ) {//助听模式
        data = {
            "title": "Settings Updated",
            "subTitle": "Steaming Mode",
            "stronger": "Headset Mode",
            "function": "",       
            "step": "Set to specified level",
            "channel": channel
        };
        if(ServerType == 32){
            data.stronger = "Hearing Aid Mode";
        }
    }
    else {
        console.warn(`未知协议 Type: ${ServerType}，跳过此参数。`);
        return null;
    }

    if(ServerType < 17){
        data.title =  DerectionStr +" "+ data.title ;
    }

    return data;
}

export { transformServerDataForApp, API_URL, transformData2UI };